/**
 * 会员中心 接口的统一出口
 */
import axios from "./http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块，把请求字段直接映射过来
// import publicData from '../config'
// const api = publicData.baseurl;
// const api = "/c-api/";

const user = {
  // 登录
  login(params) {
    return axios.post("/home/login-code", qs.stringify(params));
  },
  // 获取验证码
  code(params) {
    return axios.post("/home/common/phonecode", qs.stringify(params));
  },
  // 我的-首页
  index(params) {
    return axios.get("/home/user/center/index", { params: params });
  },
  // 我的视频
  videos(params) {
	  return axios.get("/home/user/center/videos", { params: params });
  },
  // 微信登录
  wxlogin(params) {
    return axios.post("/home/login-wx", qs.stringify(params));
  },
  // 解绑微信
  unbindWX(params) {
    return axios.post("/home/user/seting/unbind", qs.stringify(params));
  },
  // 绑定微信
  bindWX(params) {
    return axios.post("/home/user/seting/bind-wx", qs.stringify(params));
  },
  // 解绑App微信
  unbindAppWX(params) {
    return axios.post("/home/user/seting/unbindapp", qs.stringify(params));
  },
  // 绑定App微信
  bindAppWX(params) {
    return axios.post("/home/user/seting/bind-appwx", qs.stringify(params));
  },
  bindAppWXAndroid(params) {
    return axios.post("/home/user/seting/appbindwx", qs.stringify(params));
  },
  // 绑定手机号
  bindPhone(params) {
    return axios.post("/home/user/seting/bind-phone", qs.stringify(params));
  },
  // 退出登录
  logout (params) {
    return axios.post('/home/user/logout', qs.stringify(params))
  },
  // 注销账号
  cancelUser (params) {
    return axios.post('/home/user/cancel/phone', qs.stringify(params))
  }
};

// 导出接口
export default user;
